
export const groupNameRegex =
  /^(?!.* {2})[A-Za-z0-9()[\].,&\-/'@#%+:_| ]*$/;

export const toTitleCase = (s: string) =>
  s.trimStart().replace(/\b\w/g, (ch) => ch.toUpperCase());

export const normalizeSpaces = (s: string) => s.replace(/ {2,}/g, " ");

export function sanitizeGroupName(input: string) {
  const singleSpaced = normalizeSpaces(input);
  const candidate = toTitleCase(singleSpaced);

  const isEmpty = candidate.trim() === "";
  const isValid = groupNameRegex.test(candidate);
  const rejected = !isValid;

  return {
    value: candidate,
    isEmpty,
    isValid,
    rejected,
  };
}
